export const CHECKOUT_LINKS = {
  base: 'https://checkout.tusbeneficios.shop/cart/51488008863977:1',
  pro: 'https://checkout.tusbeneficios.shop/cart/51488009879785:1',
} as const

export type PlanKey = keyof typeof CHECKOUT_LINKS

export function goToCheckout(plan: PlanKey) {
  // Fire Meta Pixel InitiateCheckout if the pixel is loaded
  if (typeof window !== 'undefined' && (window as any).fbq) {
    ;(window as any).fbq('track', 'InitiateCheckout')
  }
  window.location.href = CHECKOUT_LINKS[plan]
}
